<!--
 * @Author: LiZhiWei
 * @Date: 2026-06-02 08:54:03
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-06-02 17:18:39
 * @Description: 
-->
<template>
  <section
    id="values"
    ref="valuesSection"
    class="landing-container lt-sm:px-32px scroll-mt-70px pt-112px pb-80px lt-sm:py-120px bg-white transition-all duration-1000 ease-out"
    :class="[isValuesVisible ? 'translate-y-0 opacity-100' : 'translate-y-50px opacity-0']"
    data-section
  >
    <section-heading title="四大价值，驱动物业数字化" />

    <div class="mb-64px gap-20px lt-sm:grid-cols-2 lt-sm:gap-25px grid grid-cols-4">
      <article
        v-for="item in values"
        :key="item.title"
        class="min-h-147px gap-18px rounded-16px border-#e2e8f0 p-24px hover:-translate-y-4px hover:border-#bfd6ff lt-sm:min-h-300px lt-sm:gap-24px flex flex-col items-start border bg-white transition-all duration-220 hover:shadow-[0_16px_40px_rgba(15,23,42,0.06)]"
      >
        <i class="h-58px w-58px lt-sm:h-96px lt-sm:w-96px object-contain" :class="item.icon"></i>
        <div>
          <h3
            class="pf-sc-semibold mb-12px text-#0f172a lt-sm:font-s-32px lt-sm:leading-[40px] m-0 text-[18.72px] leading-[1.4]"
          >
            {{ item.title }}
          </h3>
          <p
            class="pf-sc-regular font-s-16px text-#64748b lt-sm:font-s-24px lt-sm:leading-[36px] m-0 leading-[1.6] break-words"
          >
            {{ item.text }}
          </p>
        </div>
      </article>
    </div>

    <div
      class="min-h-320px mt-120px lt-sm:mt-160px lt-sm:ml-[calc((100%-100vw)/2)] lt-sm:w-screen lt-sm:min-h-auto relative ml-[calc((100%-min(100vw,1914px))/2)] w-[min(100vw,1914px)] overflow-hidden"
    >
      <div
        class="mb-40px gap-32px lt-sm:mb-40px lt-sm:gap-30px mx-auto flex w-[min(1440px,calc(100%-412px))] items-center justify-center"
      >
        <span
          class="h-2px w-320px lt-sm:w-85px bg-[linear-gradient(90deg,transparent_0%,#E5E9F5_100%)]"
        ></span>
        <p
          class="pf-sc-regular font-s-18px text-#9CA0A7 lt-sm:font-s-28px m-0 text-center whitespace-nowrap"
        >
          携手合作伙伴，深耕物业数字化
        </p>
        <span
          class="h-2px w-320px lt-sm:w-85px bg-[linear-gradient(90deg,#E5E9F5_0%,transparent_100%)]"
        ></span>
      </div>

      <div
        class="-mt-6px relative flex w-screen max-w-screen flex-col gap-0 overflow-hidden"
        aria-label="合作伙伴滚动展示"
      >
        <inspira-marquee
          v-for="(row, rowIndex) in partnerLogoRows"
          :key="rowIndex"
          pause-on-hover
          :reverse="rowIndex === 1"
          class="[--duration:80s] [--gap:24px]"
          :class="rowIndex === 0 ? 'mb-[-31px]' : rowIndex === 1 ? '[--delay:-20s]' : ''"
        >
          <div
            v-for="logo in row"
            :key="logo.name"
            class="h-80px w-200px rounded-8px px-24px lt-sm:h-105px lt-sm:w-290px flex shrink-0 items-center justify-center bg-white shadow-[0_2px_8px_2px_rgba(0,0,0,0.06)]"
          >
            <img class="h-full w-full object-contain" :src="logo.src" :alt="`${logo.name} logo`" />
          </div>
        </inspira-marquee>
        <div
          class="pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-[linear-gradient(to_right,#fff,transparent)]"
        ></div>
        <div
          class="pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-[linear-gradient(to_left,#fff,transparent)]"
        ></div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import SectionHeading from '../section-heading.vue'

  import { partnerLogoRows, values } from '~/constants/huiguanjia-home'

  defineOptions({
    name: 'ValuesSection',
  })

  const valuesSection = useTemplateRef<HTMLElement>('valuesSection')
  const { isVisible: isValuesVisible } = useScrollReveal(valuesSection)
</script>
